import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "time-of-day-condition" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = {
  key: 0,
  class: "time-of-day-condition__online-times-picker"
}
const _hoisted_5 = { class: "time-of-day-condition__control" }

import BusinessHoursSelection from '@/features/bots/components/businessHoursSelection/BusinessHoursSelection.vue';
import { ConditionViewModel } from '../models/conditionViewModel';
import { BusinessHoursViewModel } from '@/features/bots/models';
import { BusinessHoursOptions } from '@/features/bots/components/businessHoursSelection';
import { PropType, ref, onMounted } from 'vue';

enum ScheduleType {
  InHours,
  OutOfHours,
  CustomTimes,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeOfDayCondition',
  props: {
  condition: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
},
  emits: ["changed", "completed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const customTimes = ref<BusinessHoursViewModel[]>([]);
const scheduleType = ref<ScheduleType>(ScheduleType.InHours);

const timeOfDayOptions = [
  { value: ScheduleType.InHours, label: 'In hours' },
  { value: ScheduleType.OutOfHours, label: 'Out of hours' },
  { value: ScheduleType.CustomTimes, label: 'Custom' },
];

const liveCondition = ref<ConditionViewModel>({
  attribute: '',
  operation: '',
  type: '',
  value: '',
  result: true,
});

onMounted(() => {
  liveCondition.value = props.condition;
  setConditionType();
  handleSelectionChange(scheduleType.value);
});

function handleSelectionChange(type: ScheduleType): void {
  scheduleType.value = type;
  if (type === ScheduleType.InHours) {
    selectInHours();
  } else if (type === ScheduleType.OutOfHours) {
    selectInHours(false);
  } else if (type === ScheduleType.CustomTimes) {
    selectCustomSchedule();
  }
  emit('changed', liveCondition.value);
}

function customScheduleChanged() {
  liveCondition.value.result = true;
  liveCondition.value.value = JSON.stringify(customTimes.value);
  emit('changed', liveCondition.value);
}

function customScheduleInvalid(invalid: boolean) {
  liveCondition.value.invalid = invalid;
}

function complete() {
  emit('completed', liveCondition.value);
}

function selectInHours(isInHours: boolean = true) {
  liveCondition.value = {
    attribute: props.condition.attribute,
    operation: 'in',
    type: props.condition.type,
    value: 'bot.openingTimes',
    result: isInHours,
    unit: props.condition.unit,
    invalid: false,
  };
}

function setConditionType() {
  if (!liveCondition.value.value) {
    return;
  }
  if (liveCondition.value.value === 'bot.openingTimes') {
    scheduleType.value = liveCondition.value.result ? ScheduleType.InHours : ScheduleType.OutOfHours;
  } else {
    scheduleType.value = ScheduleType.CustomTimes;
  }
}

function selectCustomSchedule() {
  liveCondition.value.result = true;
  try {
    customTimes.value = JSON.parse(liveCondition.value.value);
  } catch {
    customTimes.value = [BusinessHoursOptions.getDefaultModel()];
    liveCondition.value.value = JSON.stringify([BusinessHoursOptions.getDefaultModel()]);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_radio_buttons = _resolveComponent("n-radio-buttons")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_n_radio_buttons, {
          modelValue: scheduleType.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((scheduleType).value = $event)),
            handleSelectionChange
          ],
          label: "Business Hours",
          options: timeOfDayOptions,
          hideLabel: true
        }, null, 8, ["modelValue"])
      ])
    ]),
    (scheduleType.value === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(BusinessHoursSelection, {
            modelValue: customTimes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customTimes).value = $event)),
            allowEmpty: false,
            onError: customScheduleInvalid,
            onInput: customScheduleChanged
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_n_button, {
        variant: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (complete()))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Done")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})